import React from "react";
import { Link } from 'react-router-dom';

import { menu } from './menus';

const Navbar = () => {

   const handleSubmenu = ( evt ) => {
      let _target   = evt.target;
      let tag_name  = evt.target.tagName;
      let tag_class = evt.target.classList;
      let target_element;

      if ( tag_name === 'SPAN' ) {

         if ( tag_class.value === 'fa arrow' ) {
            target_element = _target.parentNode.parentNode.nextSibling;
         } else if ( tag_class.value === 'hide-menu' ) {
            target_element = _target.parentNode.nextSibling;
         }

      } else if ( tag_name === 'A' ) {
         target_element = _target.nextSibling;
      } else if ( tag_name === 'I' ) {
         target_element = _target.parentNode.nextSibling;
      }
      
      if ( target_element.classList.contains('in') ) {
         target_element.className = 'nav nav-second-level collapse';
      } else {
         target_element.className = 'nav nav-second-level collapse in';
      }
      
   }

   const renderLinkPrincipal = ( item, i ) => {

      if (item.submenus.length > 0 ) {
         return (
            <a className = {`waves-effect ${ i === 0 ? 'active' : '' }`} onClick = { handleSubmenu }>
               <i className={ item.icon } style = {{ color: 'black' }}></i>
               <span className="hide-menu" style = {{ color: 'black' }}> { item.name } <span className="fa arrow"></span> </span>
            </a>
         )
      } else {
         return (
            <Link to = { item.path } className = {`waves-effect ${ i === 0 ? 'active' : '' }`}>
               <i className={ item.icon } style = {{ color: 'black' }}></i>
               <span className="hide-menu" style = {{ color: 'black' }}> { item.name } <span className="fa arrow"></span> </span>
            </Link>
         );
      }
   }

   return (
      <div className="navbar-default sidebar" role="navigation">
         <div className="sidebar-nav navbar-collapse slimscrollsidebar">
            <ul className="nav" id = "side-menu">
               {
                  menu.map( (item, i) => {
                     return (
                        <li key = { i }>
                           { renderLinkPrincipal(item, i) }
                           <ul className = "nav nav-second-level collapse">
                              {
                                 item.submenus.length > 0 ?
                                    item.submenus.map( (sub, j) => {
                                       return(
                                          <li key = { j }>
                                             <Link to = { sub.sub_path}> <span style = {{ color: 'black' }}>{sub.sub_name }</span></Link>
                                          </li>
                                       )
                                    })
                                 : null
                              }
                           </ul>
                        </li>
                     )
                  })
               }
            </ul>
         </div>
      </div>
   )
};

export default Navbar;